import { JSX } from 'react';
import { Heading, Layout, Text } from '../../../components/core';
import { getStylesheet } from '../../../styles';
import { OfAgeForm } from '../../onboarding/forms/OfAgeForm';

type TermsRequiredProps = {
  onSaved?: () => void;
};

export const TermsRequired = (props?: TermsRequiredProps): JSX.Element => {
  const { onSaved } = props ?? {};

  return (
    <Layout.VStack space={6}>
      <Layout.VStack {...styles.textStack} space={4}>
        <Heading.h3 center level={1}>
          Please review our Terms
        </Heading.h3>

        <Text.para {...styles.description} center>
          In order to access Mantra Health, please agree to the Terms of Service, Telehealth
          Consent, and Privacy Policy.
        </Text.para>
      </Layout.VStack>

      <OfAgeForm onSaved={onSaved} />
    </Layout.VStack>
  );
};

const styles = getStylesheet({
  textStack: {
    alignItems: 'stretch',
  },

  description: {
    alignSelf: 'center',
    maxWidth: '327px',
  },
});
